import { ResponseDto } from '@diritto/common/base/response.dto';
import { Http } from '@diritto/common/utils/requester/http';

export class ContentAuthorReplyApi {
  constructor(
    protected url: string,
    protected http: Http,
  ) {}

  async deleteReply(contentId: number, replyId: number): Promise<ResponseDto> {
    const res = await this.http.delete<ResponseDto>(`${this.url}/contents/${contentId}/replies/${replyId}`);
    return res.data;
  }
}
